<template>
    <v-container grid-list-md fluid>
        <v-layout row wrap>
            <v-flex xs12 md6>
                <v-card style="height: 300px;">
                    <v-card-title primary-title>
                        <v-toolbar dense
                                   color="primary"
                                   dark
                        >
                            <v-toolbar-title>Anagrafiche Clienti</v-toolbar-title>
                        </v-toolbar>
                    </v-card-title>

                    <v-card-text style="height: 150px;">
                        <label class="subheading">Clienti censiti in anagrafica: </label>
                        <label class="headline"></label>
                        <br/><br/>
                        clicca su "Accedi" per visualizzare e modificare
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn big flat color="accent" @click="$router.push({name:'subjects'});">Accedi</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12 md6>
                <v-card style="min-height: 300px;">
                    <v-card-title primary-title>
                        <v-toolbar dense
                                   color="primary"
                                   dark
                        >
                            <v-toolbar-title>Prodotti e Servizi</v-toolbar-title>
                        </v-toolbar>
                    </v-card-title>

                    <v-card-text style="min-height: 150px;">
                        <label class="subheading">Prodotti/servizi censiti in anagrafica: </label>
                        <label class="headline"></label>
                        <br/><br/>
                        clicca su "Accedi" per visualizzare e modificare
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="accent" @click="$router.push({name:'products'});">Accedi</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex xs12 md6>
            <v-card style="min-height: 300px;">
              <v-card-title primary-title>
                <v-toolbar dense
                           color="primary"
                           dark
                >
                  <v-toolbar-title>Indirizzo Telematico di Consegna Fatture</v-toolbar-title>
                </v-toolbar>
              </v-card-title>

              <v-card-text style="min-height: 150px;">
                <label class="subheading"></label>
                <label class="headline"></label>


              </v-card-text>
            </v-card>
          </v-flex>
            <v-flex xs12 md6>
            <v-card style="min-height: 300px;">
              <v-card-title primary-title>
                <v-toolbar dense
                           color="primary"
                           dark
                >
                  <v-toolbar-title>QR Code</v-toolbar-title>
                </v-toolbar>
              </v-card-title>

              <v-card-text style="min-height: 150px;">
                <label class="subheading"></label>
                <label class="headline"></label>

              </v-card-text>
            </v-card>
          </v-flex>
            <v-flex xs12>
                <v-card style="min-height: 300px;">
                    <v-card-title primary-title>
                        <v-toolbar dense
                                   color="primary"
                                   dark
                        >
                            <v-toolbar-title>Conti Bancari</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" @click="addBank()">
                                Crea
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card-title>

                    <v-card-text style="min-height: 150px;">
                        <v-list dense>
                            <v-list-tile avatar v-for="item in paymentBanks" :key="item.Id">
                                <v-list-tile-avatar>
                                    <v-icon>fas fa-university</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                                    <v-list-tile-sub-title>
                                        {{item.Iban}}

                                        <template v-if="item.Details">
                                           &nbsp; - {{item.Details}}
                                        </template>

                                        <template v-if="item.ExternalCode">
                                            &nbsp; ({{item.ExternalCode}})
                                        </template>
                                    </v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn icon @click="editBank(item)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                                <v-list-tile-action>
                                    <v-btn icon @click="deleteBank(item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="bankDialog" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-card-title>
                    <span class="headline">
                        <v-icon>fas fa-university</v-icon>
                        &nbsp; Modifica Banca
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nome del Conto" required hint="Usato per identificare il conto" v-model="selectedBank.Name"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="IBAN" required hint="IBAN del conto corrente" counter="27" v-model="selectedBank.Iban"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Filiale" hint="Nome e indirizzo della filiale (o altri dati di dettaglio)" v-model="selectedBank.Details"></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="$store.state.customer.Options.ContabilitaLight">
                                <v-text-field label="Codice Conto" hint="Codice Conto Contabilità" v-model="selectedBank.ExternalCode"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" @click="bankDialog = false">Annulla</v-btn>
                    <v-btn color="success" @click="saveBank">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

    import DomainDataApi from '@/api/domaindata';

    export default {
        name: "Masterdata",
        data() {
            return {
                paymentBanks: [],
                counters: {},
                bankDialog: false,
                selectedBank: {},
            }
        },
        created: function () {
            DomainDataApi.getPaymentBanksList()
                .then(t => {
                    this.paymentBanks = t.data;
                });
        },
        methods: {
            addBank: function () {
                DomainDataApi.newPaymentBank()
                    .then(t => {
                        this.paymentBanks.push(t.data);
                    });
            },
            editBank: function(item) {
                this.selectedBank = item;
                this.bankDialog = true;
            },
            saveBank: function() {
                DomainDataApi.savePaymentBank(this.selectedBank)
                    .then(() => {
                        this.bankDialog = false;
                    });
            },
            deleteBank: function(item) {
                if (window.confirm('Eliminare la riga?')) {
                    DomainDataApi.deletePaymentBank(item.Id)
                        .then(() => {
                            this.paymentBanks.splice(this.paymentBanks.indexOf(item), 1);
                        });
                }
            },
        }
    }
</script>

<style scoped>

</style>